import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon from '@divvy-web/skylab.icon'

import styles from './styles.module.scss'

const CheckWithIncludedLabel = () => {
  const [getClassName] = useNameFormatter('CheckWithIncludedLabel')

  return (
    <div className={styles[getClassName('')]}>
      <Icon
        className={styles[getClassName('check')]}
        name='check'
      />
      <FormattedMessage
        defaultMessage='Included'
        id='sputnik.CheckWithIncludedLabel__ULRaOP'
      />
    </div>
  )
}

export default CheckWithIncludedLabel
